/**
 * Definicion de los TRES SITIOS de la Fundacion Jeshua Ben Joseph (Definicion 35).
 *
 *   jeshua.ong  Global / mundial      33 idiomas   100% de las canalizaciones
 *   jeshua.es   Europa                33 idiomas   100% de las canalizaciones
 *   jeshua.cl   America Latina y Caribe  5 idiomas  100% de las canalizaciones
 *
 * El CONTENIDO es el mismo en los tres sitios y sale SIEMPRE de jeshua.ong
 * (las 278 canalizaciones con sus seis lentes): jeshua.ong es la fuente unica.
 * Lo que cambia entre sitios son los idiomas disponibles y los datos de
 * contacto de cada territorio.
 *
 * Esta es la unica fuente de verdad por dominio. Ningun componente debe volver
 * a leer window.location.hostname por su cuenta.
 */

/** Los 33 idiomas (Definicion 35): 25 base + 8 de mayor cobertura mundial. */
import { IDIOMAS_LISTOS } from './idiomas_listos';

export const ALL_LANGUAGES = [
  // 25 base
  'en', 'es', 'fr', 'de', 'pt', 'it', 'nl', 'pl', 'ru', 'id',
  'tr', 'vi', 'zh', 'hi', 'ar', 'bn', 'ja', 'te', 'ko', 'ta',
  'mr', 'th', 'gu', 'fa', 'ur',
  // 8 nuevos
  'sw', 'ha', 'yo', 'am', 'fil', 'pa', 'yue', 'uk'
];

/**
 * Los 33 idiomas de jeshua.es: Europa y el Mediterraneo.
 * (a) Los 11 europeos que ya estan en jeshua.ong: en es fr de pt it nl pl ru uk tr
 * (b) 23 de las 24 lenguas oficiales de la Union Europea.
 * (c) Seis lenguas europeas de peso fuera de la UE.
 * (d) El hebreo.
 * APROBADA por Faina el 23-ago-2026. 🔴 CAMBIO 21-sep-2026 (Faina: «entra Israel,
 * sale el maltes»): el hebreo reemplaza al maltes. El maltes aportaba ~500 mil
 * hablantes que leen ingles; el hebreo son 9 millones y es la lengua de la
 * tierra de Jeshua, Maria, Ana y los esenios. Con esto .es deja de ser «la UE
 * completa» y pasa a ser Europa y el Mediterraneo. El maltes sigue traducido
 * en la tabla, fuera del selector, por si vuelve.
 */
export const EUROPEAN_LANGUAGES = [
  // Ya presentes en jeshua.ong (11)
  'en', 'es', 'fr', 'de', 'pt', 'it', 'nl', 'pl', 'ru', 'uk', 'tr',
  // Resto de lenguas oficiales de la UE (15; el maltes salio el 21-sep)
  'ro', 'el', 'hu', 'cs', 'sv', 'bg', 'da', 'fi', 'sk', 'hr', 'lt',
  'sl', 'lv', 'et', 'ga',
  // Europeas de peso fuera de la UE (6)
  'ca', 'sq', 'sr', 'nb', 'bs', 'mk',
  // El hebreo (Faina, 21-sep-2026)
  'he'
];

/** Los idiomas de America Latina y el Caribe: uno por cada uno de los 33
 *  paises de .cl (Def 91 + Faina 11-sep: «esos idiomas los debemos crear en
 *  cl, 1 idioma por cada pais»). 18 paises hablan espanol, Brasil portugues,
 *  Haiti frances, Surinam holandes y 13 del Caribe ingles: cinco idiomas.
 *  La lista de paises con su idioma vive en `paises_cl.js`. */
export const LATAM_LANGUAGES = ['es', 'pt', 'en', 'fr', 'nl'];

/**
 * Fuente unica del contenido: los tres sitios muestran las canalizaciones
 * de jeshua.ong. Ninguno tiene catalogo propio.
 */
export const CONTENT_SITE = 'jeshua.ong';

/** Idiomas escritos de derecha a izquierda. */
export const RTL_LANGUAGES = ['ar', 'fa', 'ur', 'he'];

/**
 * Idiomas que YA tienen su archivo public/locales/<lng>/common.json.
 * Al agregar un idioma nuevo basta con crear su carpeta y sumarlo aqui:
 * el selector del sitio lo toma solo.
 *
 * ✅ LOS 33 (28-ago). Tener archivo NO significa estar traducido —los ocho
 * ultimos estan vacios de traduccion— y por eso ya no basta esta lista para
 * ofrecer un idioma: hace falta ademas pasar la medicion de cobertura.
 * Ver `getSiteLanguages` e `idiomas_listos.js`.
 */
export const AVAILABLE_LOCALES = [
  'ar', 'bn', 'de', 'en', 'es', 'fa', 'fr', 'gu', 'hi', 'id',
  'it', 'ja', 'ko', 'mr', 'nl', 'pl', 'pt', 'ru', 'ta', 'te',
  'th', 'tr', 'ur', 'vi', 'zh',
  // los ocho que cierran la Def 35
  'sw', 'ha', 'yo', 'am', 'fil', 'pa', 'yue', 'uk',
  // los 22 de jeshua.es (traducidos y retrotraducidos el 14/15-sep-2026;
  // ga y mt con aviso de confianza media-baja en el informe, decision Faina)
  'ro', 'el', 'hu', 'cs', 'sv', 'bg', 'da', 'fi', 'sk', 'hr', 'lt',
  'sl', 'lv', 'et', 'ga', 'ca', 'sq', 'sr', 'nb', 'bs', 'mk',
  // el hebreo (Faina, 21-sep-2026: entra Israel, sale el maltes)
  'he'
];

/* IDIOMAS FUTUROS (Faina, 22-sep-2026: «en principio son 55 idiomas; deja el
   maltes fuera como futuros idiomas»). No se ofrecen ni se cuentan, y no se
   borra nada: su locale sigue en public/locales, su hoja sigue en la tabla de
   traduccion y su glosario sigue en la skill. Para volver a ofrecer uno, se
   saca de aqui y se mete en AVAILABLE_LOCALES y en la lista de su sitio. */
export const IDIOMAS_FUTUROS = ['mt'];

export const LANGUAGE_NAMES = {
  am: 'አማርኛ',
  bg: 'Български',
  bs: 'Bosanski',
  ca: 'Català',
  cs: 'Čeština',
  da: 'Dansk',
  el: 'Ελληνικά',
  et: 'Eesti',
  fi: 'Suomi',
  ga: 'Gaeilge',
  hr: 'Hrvatski',
  hu: 'Magyar',
  lt: 'Lietuvių',
  lv: 'Latviešu',
  mk: 'Македонски',
  he: 'עברית',
  nb: 'Norsk',
  ro: 'Română',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  sq: 'Shqip',
  sr: 'Српски',
  sv: 'Svenska',
  ar: 'العربية',
  bn: 'বাংলা',
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fa: 'فارسی',
  fil: 'Filipino',
  fr: 'Français',
  gu: 'ગુજરાતી',
  ha: 'Hausa',
  hi: 'हिन्दी',
  id: 'Indonesia',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  mr: 'मराठी',
  nl: 'Nederlands',
  pa: 'ਪੰਜਾਬੀ',
  pl: 'Polski',
  pt: 'Português',
  ru: 'Русский',
  sw: 'Kiswahili',
  ta: 'தமிழ்',
  te: 'తెలుగు',
  th: 'ภาษาไทย',
  tr: 'Türkçe',
  uk: 'Українська',
  ur: 'اردو',
  vi: 'Tiếng Việt',
  yo: 'Yorùbá',
  yue: '粵語',
  zh: '中文'
};

/** Los tres sitios. La clave es el dominio. */
export const SITES = {
  'jeshua.ong': {
    key: 'ong',
    /* Def 75: el sitio internacional sirve a todo el mundo; su espanol es el neutro/latam. */
    variante: 'es-419',
    site: 'jeshua.ong',
    contentSite: CONTENT_SITE,
    domain: 'www.jeshua.ong',
    label: 'www.jeshua.ong',
    scope: 'global',
    languages: ALL_LANGUAGES,
    defaultLanguage: 'en',
    email: 'contacto@jeshua.ong',
    whatsapp: { number: '+56 9 6822 4080', url: 'https://wa.me/56968224080' },
    // ⚠️ CONFIRMAR CON FAINA antes de publicar: el pie de un sitio que cobra
    // suscripciones tiene que decir quien vende, y tiene que ser exacto.
    legalName: 'Fundación Jeshua Ben Joseph',
    taxId: 'RUT 65.274.966-6',
    address: 'Santiago de Chile'
  },
  'jeshua.es': {
    key: 'es',
    /* Def 75: espanol de Espana, tambien en las canalizaciones (Def 75). */
    variante: 'es-ES',
    /* Def 97 (02-10-2026): la CONSERVACION pasa a una etapa futura y NO se
       publica. Se parte solo con canalizaciones. Queda en false a proposito:
       apagar esta bandera retira el enlace del menu (Header), la pagina del
       listado (paginas.js) y la ruta (Router). Cuando se retome la etapa, se
       vuelve a poner en true en .cl y .es y todo reaparece. La Def 74 (como se
       reciben donaciones de tierra) y la Def 83 (solo .cl y .es) siguen
       escritas y vigentes para ese momento. */
    conservacion: false,
    site: 'jeshua.es',
    contentSite: CONTENT_SITE,
    domain: 'www.jeshua.es',
    label: 'www.jeshua.es',
    scope: 'europa',
    languages: EUROPEAN_LANGUAGES,
    defaultLanguage: 'es',
    fixedInitialLanguage: 'es',
    email: 'contacto@jeshua.ong',
    whatsapp: { number: '+34 617 59 84 63', url: 'https://wa.me/34617598463' },
    // ⚠️ El vehiculo español todavia no tiene sus datos aqui: hacen falta antes
    // de abrir en Europa, junto con el aviso legal y la privacidad.
    legalName: 'Fundación Jeshua Ben Joseph',
    taxId: '',
    address: 'España'
  },
  'jeshua.cl': {
    key: 'cl',
    /* Def 75: espanol latinoamericano (Def 75). */
    variante: 'es-419',
    /* Def 97 (02-10-2026): la CONSERVACION pasa a una etapa futura y NO se
       publica. Se parte solo con canalizaciones. Queda en false a proposito:
       apagar esta bandera retira el enlace del menu (Header), la pagina del
       listado (paginas.js) y la ruta (Router). Cuando se retome la etapa, se
       vuelve a poner en true en .cl y .es y todo reaparece. La Def 74 (como se
       reciben donaciones de tierra) y la Def 83 (solo .cl y .es) siguen
       escritas y vigentes para ese momento. */
    conservacion: false,
    site: 'jeshua.cl',
    contentSite: CONTENT_SITE,
    domain: 'www.jeshua.cl',
    label: 'www.jeshua.cl',
    scope: 'latam',
    languages: LATAM_LANGUAGES,
    defaultLanguage: 'es',
    fixedInitialLanguage: 'es',
    email: 'contacto@jeshua.ong',
    whatsapp: { number: '+56 9 6822 4080', url: 'https://wa.me/56968224080' },
    legalName: 'Fundación Jeshua Ben Joseph',
    taxId: 'RUT 65.274.966-6',
    address: 'Santiago de Chile'
  }
};

/** Sitio por defecto cuando el dominio no identifica a ninguno (por ejemplo, localhost). */
export const DEFAULT_SITE = 'jeshua.ong';

/** Clave de localStorage para probar los tres sitios en local: ?site=cl|es|ong */
const SITE_OVERRIDE_KEY = 'jeshua_site';

const siteByKey = (key) =>
  Object.values(SITES).find((site) => site.key === key) || null;

/**
 * Solo en desarrollo (localhost): permite mirar cualquiera de los tres sitios
 * agregando ?site=cl, ?site=es o ?site=ong a la direccion. La eleccion queda
 * guardada hasta que se elija otra.
 */
const getDevOverride = () => {
  if (typeof window === 'undefined') return null;
  const { hostname, search } = window.location;
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  if (!isLocal) return null;

  const requested = new URLSearchParams(search).get('site');
  if (requested) {
    const site = siteByKey(requested.replace('jeshua.', ''));
    if (site) {
      window.localStorage.setItem(SITE_OVERRIDE_KEY, site.key);
      return site;
    }
  }
  return siteByKey(window.localStorage.getItem(SITE_OVERRIDE_KEY));
};

/** Devuelve la configuracion del sitio que se esta viendo. */
export const getSiteConfig = () => {
  const override = getDevOverride();
  if (override) return override;

  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname.includes('jeshua.ong')) return SITES['jeshua.ong'];
  if (hostname.includes('jeshua.es')) return SITES['jeshua.es'];
  if (hostname.includes('jeshua.cl')) return SITES['jeshua.cl'];
  return SITES[DEFAULT_SITE];
};

/**
 * Sitio propio: identifica al sitio ante la API (por ejemplo, al sincronizar
 * contenido desde el panel de administracion).
 */
export const getSite = () => getSiteConfig().site;

/**
 * Sitio del que se pide el CONTENIDO. Siempre jeshua.ong: los tres sitios
 * muestran las mismas canalizaciones, cada uno en sus idiomas.
 */
export const getContentSite = () => getSiteConfig().contentSite || CONTENT_SITE;

/**
 * Idiomas que el sitio actual ofrece hoy: los que le corresponden por
 * definicion, tienen su archivo de traduccion Y ESTAN TRADUCIDOS DE VERDAD.
 *
 * 🔴 LA TERCERA CONDICION ES NUEVA (28-ago). Tener el archivo no era suficiente:
 * los 25 idiomas tenian las 203 claves, pero 135 con el TEXTO ESPAÑOL COPIADO
 * dentro — en japones, en arabe y tambien en ingles. El selector ofrecia 25
 * idiomas y el sitio estaba en español a dos tercios.
 *
 * Ninguno pasaba del 38 %. Hoy, por tanto, solo se ofrece el español, y eso es
 * exactamente lo que hay. Regla dura de Faina: todo lo que publicamos debe ser
 * verdad — y ofrecer un idioma es publicar una promesa.
 *
 * ⚠️ Es automatico y se deshace solo: en cuanto la tabla de textos se complete
 * y se importe, `cobertura_idiomas.py escribir` los vuelve a poner. Nadie tiene
 * que acordarse de nada.
 */
export const getSiteLanguages = (config = getSiteConfig()) =>
  config.languages.filter(
    (lng) => AVAILABLE_LOCALES.includes(lng) && IDIOMAS_LISTOS.includes(lng)
  );

/**
 * Los que le corresponden por definicion y tienen archivo, TRADUCIDOS O NO.
 * Sirve para poder decir «vamos por 1 de 33» sin mentir en ninguna direccion.
 */
export const getSiteLanguagesPrevistos = (config = getSiteConfig()) =>
  config.languages.filter((lng) => AVAILABLE_LOCALES.includes(lng));

/**
 * ¿ESTE SITIO OFRECE CONSERVACION DE TIERRAS? (Def 74, 30-ago-2026).
 *
 * Solo .cl y .es. No es una decision de menu: el servicio se presta con las
 * leyes de un pais concreto —en Chile el derecho real de conservacion de la
 * Ley 20.930, en Espana el acuerdo de custodia del territorio de la Ley
 * 42/2007— y la Fundacion tiene vehiculo legal en esos dos sitios y en
 * ninguno mas. Ofrecerlo en el sitio internacional seria prometer algo que no
 * podemos cumplir alli donde vive quien lo lee.
 *
 * Por eso la RUTA tampoco existe en .ong: no basta con no enlazarla. Router.js
 * y Header.jsx leen las dos esta misma funcion.
 */
export const ofreceConservacion = (config = getSiteConfig()) =>
  Boolean(config.conservacion);

/**
 * LA VARIANTE DEL ESPANOL DE ESTE SITIO (Definicion 75, 30-ago-2026).
 *
 * Faina: «en la pagina .es todo debe ir en Espanol (Espana), incluso las
 * canalizaciones. En el .cl es Espanol (Latinoamericano)».
 *
 * No es un detalle de estilo. Las canalizaciones hablan a UNA sola persona y
 * la llaman por su nombre; si el lector tropieza con una palabra que en su
 * pais no se dice asi, deja de ser un mensaje para el y pasa a ser un texto
 * traido de fuera. Es exactamente lo contrario de lo que la pieza viene a
 * hacer.
 *
 * Se devuelve la etiqueta BCP-47, que es lo que entienden el navegador, los
 * buscadores y los lectores de pantalla: `es-ES` y `es-419` (el 419 es el
 * codigo de Latinoamerica en la norma). Va en el atributo `lang` del
 * documento y en las etiquetas hreflang.
 *
 * ⚠️ HOY LAS PIEZAS ESTAN EN UNA SOLA VARIANTE. Declarar `es-ES` no las
 * convierte: la adaptacion es trabajo de contenido, no de codigo, y la
 * escribe Faina. Mientras no exista, el candado de produccion impide publicar
 * jeshua.es prometiendo un espanol que no esta escrito.
 */
export const varianteDelSitio = (config = getSiteConfig()) =>
  config.variante || 'es-419';

/** Los otros dos sitios, para enlazarlos desde el pie de pagina. */
export const getSiblingSites = (config = getSiteConfig()) =>
  Object.values(SITES).filter((site) => site.key !== config.key);
